import { useState, useEffect, ChangeEvent } from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { noUndefinedNoNull } from './Inputs.utils';
import { Typography, TTextType } from '@ts/storybook';

//#region Interfaces
interface OptionProps {
  value: string | number;
  label: TTextType;
  disabled?: boolean;
  style?: object;
}

interface RadioButtonGroupProps {
  title?: string | string[];
  value: string | number;
  disabled?: boolean;
  onChange: (value: string) => void;
  options: OptionProps[];
  row?: boolean;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
}
//#endregion

const RadioButtonGroup = ({ labelPlacement = 'end', options, title, row, onChange, ...props }: RadioButtonGroupProps) => {
  //#region Handler
  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value === '' ? '' : ev.target.value;
    onChange(value);
    setValue(value);
  };
  //#endregion

  const [value, setValue] = useState(noUndefinedNoNull(props.value));

  useEffect(() => {
    setValue(noUndefinedNoNull(value));
  }, [value]);

  return (
    <FormControl component="fieldset">
      {title ? (
        <FormLabel component="legend">
          <Typography variant="h6" color="black" text={title} sx={{ fontSize: '0.95rem' }} />
        </FormLabel>
      ) : null}
      <RadioGroup row={row} sx={{ flexDirection: row ? 'row!important' : 'column' }} value={value} onChange={handleChange}>
        {options.map(optionProps => (
          <FormControlLabel
            {...optionProps}
            key={optionProps.value}
            label={<Typography text={optionProps.label} />}
            disabled={props.disabled ?? optionProps.disabled}
            control={<Radio color="primary" />}
            labelPlacement={labelPlacement}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtonGroup;
